import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router";
import Header from "../../components/sharedLayout/Header";
import Sidebar from "../../components/sharedLayout/Sidebar";
import "./sharedLayout.scss";

const hideSideBarPaths = [
  "/account/:cid",
  "/contacts/:cid",
  "/schemes-orders/:cid",
  "/fmi-cases/:cid",
  "/invoices/:cid",
  "/fmi-leads/:cid",
  "/products/:pid",
  "/orders/:oid",
];

const SharedLayout = () => {
  const location = useLocation();
  const { pathname } = location;
  const isMatchedPath = hideSideBarPaths.some((path) => {
    // Split the path into segments
    const pathSegments = path.split("/");
    const currentPathSegments = pathname.split("/");

    if (pathSegments.length !== currentPathSegments.length) {
      return false; // Path segments count mismatch, no need to check further
    }

    // Check each segment for a match
    for (let i = 0; i < pathSegments.length; i++) {
      const pathSegment = pathSegments[i];
      const currentPathSegment = currentPathSegments[i];

      if (pathSegment === currentPathSegment || pathSegment.startsWith(":")) {
        continue; // Match or parameter, continue checking
      } else {
        return false; // Segment doesn't match, break the loop
      }
    }

    return true; // All segments matched
  });

  useEffect(() => {
    if (pathname === "/orders/create") {
      document.body.classList.add("overscroll-none");
      document.getElementsByTagName("html")[0].classList.add("overscroll-none");
    } else {
      document.body.classList.remove("overscroll-none");
      document
        .getElementsByTagName("html")[0]
        .classList.remove("overscroll-none");
    }
  }, [pathname]);

  return (
    <div>
      <Header />
      <Sidebar pathname={pathname} isMatchedPath={isMatchedPath} />
      <div
        id="content"
        className={`md:w-[calc(100vw_-_110px)] w-[100vw] md:h-[calc(var(--vh)_-_70px)] ${
          pathname === "home" || isMatchedPath
            ? "h-[calc(var(--vh)_-_70px)]"
            : "h-[calc(var(--vh)_-150px)]"
        } md:absolute top-[70px] right-0	md:bottom-0 bottom-[70px] overflow-x-hidden relative z-12`}
      >
        <div className="bg-grey-100 contentDiv h-full w-full md:p-3 md:pt-3 pb-3">
          <Outlet isMatchedPath={isMatchedPath} />
        </div>
      </div>
    </div>
  );
};

export default SharedLayout;
